import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./../footer/footer.css";
import { NavLink } from "react-router-dom";
import { appstore, googleplay,partll } from "../../assets/img";
import { useDispatch, useSelector } from "react-redux";
import { fetchHomeJsonList } from "../../redux/Actions";
import SampleVideo from "../../images/sample.mp4";
import { data } from "../edit/data";
import { LOCAL_API_BASE_URL } from "../../config";

export const SET_SETTINGS = "SET_SETTINGS";

export const setSettingsAll = (payload: any) => ({
  type: SET_SETTINGS,
  payload,
});

function FooterFive() {
  const navigate = useNavigate();

  const Url = window.location.host;
  const blogUrl = `https://blog.${Url}`;
  const isXcelShop =
    window.location.href.includes("xceldrycleaner") ||
    (process.env.NODE_ENV === "development" &&
      LOCAL_API_BASE_URL?.includes("xceldrycleaner"));

  const base_url = process.env.REACT_APP_BACKEND_URL;
  // const base_url = "http://www.bestatlaundry.test";

  const [settings, setSettings] = useState<any>({});
  const homedata: any = useSelector<any>((state) => state?.homeJsonList);
  // const homedata = data
  const settingsData: any = useSelector<any>((state) => state?.settings);
  const shopHomeData: any = useSelector<any>((state) => state?.shopHome);

  const appStore =
    homedata?.theme_5?.home?.footer?.footer_section?.mobile_link_section?.ios_link;
  const playStore =
    homedata?.theme_5?.home?.footer?.footer_section?.mobile_link_section?.android_link;
  const facebook =
    Object.keys(settings).length > 0 && settings.WebsiteSettings.social_link1;
  const twitter =
    Object.keys(settings).length > 0 && settings.WebsiteSettings.social_link2;
  const instagram =
    Object.keys(settings).length > 0 && settings.WebsiteSettings.social_link6;
  const dispatch = useDispatch<any>();

  const [areaCovered, setAreaCovered] = useState<any | null>({});

  useEffect(() => {
    // if (Object.keys(settings).length === 0 && settingsData == undefined) {
    //   axios({
    //     method: "get",
    //     url: `${base_url}/api/settings`,
    //     headers: {
    //       Accept: "application/json",
    //       "Access-Control-Allow-Methods": "GET, POST",
    //     },
    //   })
    //     .then((response) => {
    //       if (response.status != 401) {
    //         setSettings(response.data.data);
    //         dispatch(setSettingsAll(response.data.data));
    //       }
    //     })
    //     .catch(function (error) {});
    // }

    const headers = {
      Accept: "application/json",
    };

    axios
      .get(`${base_url}/api/areas_covered`, {
        headers: headers,
      })
      .then((e) => {
        setAreaCovered({ data: e.data });
      });

    let URL = window.location.href.split("/");
    if (!URL.includes("shop")) {
      const faviconLink = document.getElementById(
        "favicon"
      ) as HTMLLinkElement;
      if (faviconLink) {
        faviconLink.href = settingsData.WebsiteSettings.logo_path +
        settingsData.WebsiteSettings.style_fav
      } else {
        console.error("Favicon link element not found");
      }
    }
  }, []);

  const popAreadCovered = (areaList: any) => {
    var test = Object.keys(areaList).map((location, locationindex) => {
      let cityArr = areaList[location].toString().split(",");

      return (
        <>
          {cityArr.map((city: any) => (
            <li>
              <a
                href={"/dry-cleaners/" + city}
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/dry-cleaners/" + city);
                }}
              >
                {city}
              </a>
            </li>
          ))}
        </>
      );
    });

    return test;
  };

  var dateObj = new Date();
  var year = dateObj.getUTCFullYear();
  useEffect(() => {}, [homedata]);

  return (
    <div>
      {homedata && (
        <style type="text/css">
          {`
            :root {
              --footer-header: #${homedata?.theme_5?.home?.footer?.section_heading_color};
              --footer-paragraph: #${homedata?.theme_5?.home?.footer?.section_paragraph_color};
          }
          `}
        </style>
      )}
      <footer
        className="footer"
        style={{
          background: `#${homedata?.theme_5?.home?.footer?.bg_color}`,
        }}
      >
        <div className="container">
          <div className="row footer-sectionthree">
            <div className="col-md col-sm-12">
              <div className="logo-footer">
                <a href="/">
                  <img
                    src={
                      shopHomeData?.home_page_settings?.shop_home_page_image?.logo?.[0]?.file_name ||
                      `${settingsData?.WebsiteSettings?.logo_path}${settingsData?.WebsiteSettings?.style_logo_en}` ||
                      `${Object.keys(settings).length > 0 && settings.WebsiteSettings.logo_path}${Object.keys(settings).length > 0 && settings.WebsiteSettings.style_logo_en}`
                    }
                    alt=""
                  />
                </a>
              </div>
              {homedata?.theme_5?.home?.footer?.footer_section?.about_section
                ?.is_enable && (
                <p>
                  {
                    homedata?.theme_5?.home?.footer?.footer_section
                      ?.about_section?.text
                  }
                </p>
              )}
            </div>
            <div className="col-md col-sm-12">
              <h4>{homedata?.theme_5?.home?.footer?.footer_section?.needhelp_section?.text || "Quick Links"}</h4>
              <ul>
                <li><a href="/pricelists" onClick={(e) => {
                      e.preventDefault();
                      navigate("/pricelists");
                      }} style={{
                        color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}`,
                      }}>Price List
                    </a>
                </li>
                <li><a href="/xcel-local-partnerships" onClick={(e) => {
                      e.preventDefault();
                      navigate("/xcel-local-partnerships");
                      }} style={{
                        color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}`,
                      }}>Local Partnerships
                    </a>
                </li>                                
                <li><a href="/aboutUs" onClick={(e) => {
                      e.preventDefault();
                      navigate("/aboutUs");
                      }} style={{
                        color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}`,
                      }}>About Us
                    </a>
                </li>                
                <li><a href="/termsAndConditions" onClick={(e) => {
                      e.preventDefault();
                      navigate("/termsAndConditions");
                      }} style={{
                        color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}`,
                      }}>Terms & Conditions
                    </a>
                </li>
                <li><a href="/privacyPolicy" onClick={(e) => {
                      e.preventDefault();
                      navigate("/privacyPolicy");
                      }} style={{
                        color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}`,
                      }}>Privacy Policy
                    </a>
                </li>
                <li><a href="/cookiePolicy" onClick={(e) => {
                      e.preventDefault();
                      navigate("/cookiePolicy");
                      }} style={{
                        color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}`,
                      }}>Cookie Policy
                    </a>
                </li>                
              </ul>
            </div>
            <div className="col-md col-sm-12">
              <h4>{homedata?.theme_5?.home?.footer?.footer_section?.policy_section?.text || "Explore"}</h4>
              <ul>
                <li>
                  <a href={blogUrl} onClick={(e) => {
                      e.preventDefault(); 
                      window.open(blogUrl, "_blank");
                      }} style={{
                        cursor: "pointer",
                        color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}`,
                      }}>
                        Blogs
                  </a>
                </li>                
                <li>
                  <a href="#" onClick={(e) => {
                      e.preventDefault(); }} style={{
                        cursor: "pointer",
                        color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}`,
                      }}
                      data-bs-toggle="modal" data-bs-target="#videomodal">How It Works</a>
                </li>
                {/* <li><a href="#" onClick={(e) => {
                      e.preventDefault();
                      navigate("/service-section");
                      }} style={{
                        color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}`,
                      }}>Our Services
                    </a>
                </li> */}
                <li><a href="/areaCovered" onClick={(e) => {
                      e.preventDefault();
                      navigate("/areaCovered");
                      }} style={{
                        color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}`,
                      }}>Locations
                    </a>
                </li>
                <li><a href="/contactUs" onClick={(e) => {
                      e.preventDefault();
                      navigate("/contactUs");
                      }} style={{
                        color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}`,
                      }}>Contact Us
                    </a>
                </li>
                {isXcelShop && (
                  <>
                    <li><a href="/case-studies/novotel-london-excel-laundry-partnership" onClick={(e) => { e.preventDefault(); navigate("/case-studies/novotel-london-excel-laundry-partnership"); }} style={{ color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}` }}>Hotel Case Studies</a></li>
                    <li><a href="/blog/hotel-laundry-outsourcing-london" onClick={(e) => { e.preventDefault(); navigate("/blog/hotel-laundry-outsourcing-london"); }} style={{ color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}` }}>Hotel Laundry Blog</a></li>
                  </>
                )}
              </ul>
            </div>
            <div className="col-md col-sm-12">
              <h4>{homedata?.theme_5?.home?.footer?.footer_section?.quickconnect_section?.text || "Call Today to Discuss Your Service Needs"}</h4>
              <ul>           
                <li>
                {homedata?.theme_5?.home?.footer?.footer_section?.callnow_for_Services_section?.mbl_no?.is_enable && (
                  <>
                    <p>
                      <i className="uil uil-phone me-2"></i>
                      {homedata?.theme_5?.home?.footer?.footer_section
                          ?.callnow_for_Services_section?.mbl_no?.label}{" "}
                      <a
                        href={`tel:${homedata?.theme_5?.home?.footer?.footer_section?.callnow_for_Services_section?.mbl_no?.value}`}  style={{
                          color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}`,
                        }}
                      >
                        {homedata?.theme_5?.home?.footer?.footer_section
                            ?.callnow_for_Services_section?.mbl_no?.value}
                      </a>
                    </p>
                  </>
                   )
                  }
                  {homedata?.theme_5?.home?.footer?.footer_section?.callnow_for_Services_section?.mbl_no_two?.is_enable && (
                    <>
                    <p>
                      <i className="uil uil-phone me-2"></i>
                      {homedata?.theme_5?.home?.footer?.footer_section
                          ?.callnow_for_Services_section?.mbl_no_two?.label}{" "}
                      <a
                        href={`tel:${homedata?.theme_5?.home?.footer?.footer_section?.callnow_for_Services_section?.mbl_no_two?.value}`} style={{
                          color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}`,
                        }}
                      >
                        {homedata?.theme_5?.home?.footer?.footer_section
                            ?.callnow_for_Services_section?.mbl_no_two?.value}
                      </a>
                    </p>
                  </>
                  )}
                </li>
                      
                <li>         
                  {homedata?.theme_5?.home?.footer?.footer_section?.callnow_for_Services_section?.email?.is_enable && (
                    <>
                    {/* <p>
                    
                    {homedata?.theme_5?.home?.footer?.footer_section?.callnow_for_Services_section?.email?.label}
                  </p> */}
                  <p>
                    <i className="uil uil-envelopes me-2"></i>
                    <a
                      href={`mailto:${homedata?.theme_5?.home?.footer?.footer_section?.callnow_for_Services_section?.email?.value}`}  style={{
                            color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}`,
                          }}>
                      {homedata?.theme_5?.home?.footer?.footer_section?.callnow_for_Services_section?.email?.value}                    
                    </a>
                  </p>
                  </>
                  
                   )
          }
                </li>

                <li>
                  {homedata?.theme_5?.home?.footer?.footer_section?.callnow_for_Services_section?.email_two?.is_enable && (
                  <p>
                    <i className="uil uil-envelopes me-2"></i>
                    <a
                    href={`mailto:${homedata?.theme_5?.home?.footer?.footer_section?.callnow_for_Services_section?.email_two?.value}`} style={{
                          color: `#${homedata?.theme_5?.home?.footer?.section_paragraph_color}`,
                        }}>
                      {
                        homedata?.theme_5?.home?.footer?.footer_section
                          ?.callnow_for_Services_section?.email_two?.value
                      }
                    </a>
                  </p>
                )
          }
                </li>              
                <li>
                  <p>
                    <i className="uil uil-map-marker me-2"></i>
                    {
                      homedata?.theme_5?.home?.footer?.footer_section
                        ?.callnow_for_Services_section?.address?.value
                    }
                  </p>
                </li>
              </ul>

              {(appStore || playStore) && (
                <div className="app-download-btn">
                  {appStore && (
                    <a href={appStore} target="_blank">
                      <img src={appstore} alt="App Store" />
                    </a>
                  )}
                  {playStore && (
                    <a href={playStore} target="_blank">
                      <img src={googleplay} alt="Google Play" />
                    </a>
                  )}
                </div>
              )}

            </div>
        <div
          className="modal fade"
          id="videomodal"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content modal-video">
              <video width="100%" height="auto" autoPlay loop muted>
                <source src={SampleVideo} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
          </div>
          <div className="row  footer-sectionfour">
            <div className="col-md-6 col-xs-12">
              <p className="footer-last">
                {homedata?.theme_5?.home?.footer?.site_title_en?.replace("2023", String(year))} | Powered by &nbsp;<a href="http://www.bestatservices.com" target="_blank">www.bestatservices.com</a>
              </p>
            </div>
            <div className="col-md-6 col-xs-12">
              <ul className="footer-social text-end d-flex justify-content-end">
                {homedata?.theme_5?.home?.footer?.footer_section?.social_media
                  ?.facebook?.is_enable && (
                  <li className="me-3">
                    <a
                      href={`https://${homedata?.theme_5?.home?.footer?.footer_section?.social_media?.facebook?.facebook_link}`}
                      target="_blank"
                    >
                      <i className="fab fa-facebook"></i>
                    </a>
                  </li>
                )}
                {homedata?.theme_5?.home?.footer?.footer_section?.social_media
                  ?.instagram?.is_enable && (
                  <li className="me-3">
                    <a
                      href={`https://${homedata?.theme_5?.home?.footer?.footer_section?.social_media?.instagram?.instagram_link}`}
                      target="_blank"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                )}
                {homedata?.theme_5?.home?.footer?.footer_section?.social_media
                  ?.linkedin?.is_enable && (
                  <li className="me-3">
                    <a
                      href={`https://${homedata?.theme_5?.home?.footer?.footer_section?.social_media?.linkedin?.linkedin_link}`}
                      target="_blank"
                    >
                      <i className="fab fa-linkedin"></i>
                    </a>
                  </li>
                )}
                {homedata?.theme_5?.home?.footer?.footer_section?.social_media
                  ?.youtube?.is_enable && (
                  <li className="me-3">
                    <a
                      href={`https://${homedata?.theme_5?.home?.footer?.footer_section?.social_media?.youtube?.youtube_link}`}
                      target="_blank"
                    >
                      <i className="fab fa-youtube"></i>
                    </a>
                  </li>
                )}
                {homedata?.theme_5?.home?.footer?.footer_section?.social_media
                  ?.twitter?.is_enable && (
                  <li className="me-3">
                    <a
                      href={`https://${homedata?.theme_5?.home?.footer?.footer_section?.social_media?.twitter?.twitter_link}`}
                      target="_blank"
                    >
                      <i className="fab fa-twitter"></i>
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default FooterFive;
